import Axios from "axios";
import { url } from "../../global";

const saveKanbanSuzuki = (data) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'SAVE_KANBANSUZUKI',
            payload: Axios.post(`${url}/kanban-suzuki`, {
                rack_id: data.rack_id,
                rack_name: data.rack_name,
                parts: data.parts
            }, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}

export { saveKanbanSuzuki }